import moment from 'moment'
import { IShipmentIssueStates, IShipmentIssue } from 'types/graphqlTypes'
import { TIconColor } from './types'

interface IUseSLADueStatusProps {
  priority: IShipmentIssue['priority']
  dueAt: IShipmentIssue['dueAt']
  issueStatus: IShipmentIssueStates
}

interface IUseSLADueStatus {
  /**
   * issue is within 3 hours of due date
   */
  isNearSLA: boolean
  /**
   * issue is past due
   */
  isPastSLA: boolean
  /**
   * whether or not to show status
   * if issue is resolved or does not have a due date, status is not shown
   */
  showStatus: boolean
  /**
   * color of status
   */
  color: TIconColor
  /**
   * humanized label describing time between current moment and the due datetime
   * ie. 3 hours ago, or in 3 days
   */
  slaLabel: string
}

export const useSLADueStatus = ({
  dueAt,
  issueStatus,
  priority,
}: IUseSLADueStatusProps): IUseSLADueStatus => {
  const currentMoment = moment()
  const isPastSLA = moment(dueAt).isBefore(currentMoment)
  const isNearSLA = moment(dueAt).isBetween(
    currentMoment,
    moment(currentMoment).add(3, 'h'),
    undefined,
    '[]'
  )

  const duration = moment.duration(moment(dueAt).diff(moment()))
  const slaLabel = duration.humanize(true)

  const showStatus =
    !!dueAt && moment(dueAt).isValid() && issueStatus !== IShipmentIssueStates.resolved

  let color: TIconColor
  if (!isPastSLA && !isNearSLA) color = 'coolGray8'
  else if (priority === 1 || priority === 2) color = 'error'
  else color = 'warning'

  return {
    isNearSLA,
    isPastSLA,
    showStatus,
    color,
    slaLabel,
  }
}
